
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from "@angular/router";
import { forkJoin, Observable } from 'rxjs';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthorizationService } from '../../../services/authorization.service';
import { CustomerDataService } from '../../../services/customer-data.service';
import { EntitlementService } from '../../../services/ems.service';
import { EntitlementData } from '../../../types/EntitlementData';
import { saveAs } from 'file-saver';
import { formatDate } from '@angular/common';
import { SplashService } from 'src/app/modules/services/splash.service';
import { CellpopupComponent } from 'src/app/modules/shared-components/cellpopup/cellpopup.component';
import { SnackService } from 'src/app/modules/services/snack.service';
import { ColumnData, UpdateColumnResponse } from 'src/app/modules/types/ColumnData';
import { ColumnManagerService, ColumnSaveConfig } from 'src/app/modules/services/column-manager.service';

@Component({
    selector: 'app-primary-manage',
    templateUrl: './primary-manage.component.html',
    styleUrls: [
        '../../../shared-styles/divs.scss',
        '../../../shared-styles/tables.scss',
        '../../../shared-styles/elements.scss',
        './primary-manage.component.scss'
    ],
    standalone: false,
    providers: [ColumnManagerService]
})
export class PrimaryManageComponent implements OnInit, AfterViewInit {
  pageSize = 0;
  pages = 1;
  entitlements: EntitlementData[] = new Array<EntitlementData>();
  user = "";
  accountid = "";
  accountname = "";
  dataSource: MatTableDataSource<EntitlementData> = new MatTableDataSource<EntitlementData>();
  filterActivatedState = 0;
  filterReservedState = 0;
  filterCidState = 0;
  filterProductState = "all";
  LOADDURATION = 60;
  filterString = "";
  products: string[] = new Array<string>();
  hasData = true;
  filteredRecordsTotal = 0;
  userMode = false;
  getExportDataUrl = "";
  download_started = false;
  stringSplit = "!$1$!";
  pageEvent: PageEvent = new PageEvent();
  filterPredicate?: (data: any, filter: string) => boolean;

  private saveConfig: ColumnSaveConfig = {
    tableName: 'opman-entitlements',
    saveMethod: (req) => this.ems.saveEntitlementDetailColumns(req)
  };

  //sort;
  @ViewChild(MatTable, { static: true }) table?: MatTable<any>;
  @ViewChild(MatPaginator, { static: true }) paginator?: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort?: MatSort;

  constructor(
    private datePipe: DatePipe = new DatePipe('mediumDate'),
    private ems: EntitlementService,
    private auth: AuthorizationService,
    private splash: SplashService,
    public spinner: NgxSpinnerService,
    public spinner_0: NgxSpinnerService,
    private route: ActivatedRoute,
    private customerData: CustomerDataService,
    public snackMsg: SnackService,
    public dialog: MatDialog,
    public columnManager: ColumnManagerService) {
    splash.show(this.LOADDURATION);
    this.filteredRecordsTotal = this.customerData.totalEntitlements;
    this.pageSize = this.ems.getPageSize();
    this.accountid = this.customerData.accountData.accountid;
    this.user = this.route.snapshot.paramMap.get('username') ?? "";
    let getContactAccountURL = "";
    if (this.ems.getUserMode() != true) {
      getContactAccountURL = this.ems.getContactAccountURL(this.auth.getCRMID(), 1, this.pageSize, false);
    } else {
      getContactAccountURL = this.ems.getContactAccountURL(this.auth.getCRMID(), 1, this.pageSize, false, this.accountid);
    }
    const getProducts = this.ems.getProducts();
    const getAccount = this.ems.getAccountUser(getContactAccountURL);
    const getAccountInvoices = this.ems.getAccountInvoices(this.accountid);
    const getUserSettings = this.ems.getUserSettings(this.auth.getCRMID(), this.ems.userMode);
    const pages = Math.ceil(this.customerData.totalEntitlements / this.pageSize);
    const getQueries: Observable<any>[] = new Array<Observable<any>>();
    getQueries.push(getProducts);
    getQueries.push(getAccount);
    getQueries.push(getUserSettings);
    getQueries.push(getAccountInvoices);
    for (let i = 1; i <= pages; i++) {
      if (this.ems.getUserMode() != true) {
        getQueries.push(this.ems.getEntitlements(this.customerData.accountData.accountid,
          0, 0, 0, this.filterProductState, '', i, this.pageSize, false));
      }
      else {
        getQueries.push(this.ems.getEntitlements(this.customerData.accountData.accountid,
          0, 0, 0, this.filterProductState, '', i, this.pageSize, true));
      }
    }

    forkJoin(getQueries).subscribe(next => {
      if (next == null) {
        splash.hide();
        return;
      }
      const productResult = next[0]
      const accountResult = next[1];
      const userResult:UpdateColumnResponse = next[2];
      const accountInvoiceResult = next[3];
      this.accountname = accountResult.account.name;
      this.columnManager.initColumns(userResult);
      this.entitlements = new Array<EntitlementData>();
      const productMap: Map<string, string> = new Map<string, string>();
      this.applyFilter();

      for (let i = 1; i <= next.length - 1; i++) {
        const getEntitlementsResult = next[i]
        for (const e in getEntitlementsResult.entitlements) {
          const entitlement: EntitlementData = getEntitlementsResult.entitlements[e];

          // add in product info
          const product = productResult.filter((value) => value.Id == entitlement.productmapid)[0];
          entitlement.productname = product.ProductName;

          // add in invoice info
          const invoice = accountInvoiceResult.filter((value) => entitlement.crminvoiceid != null && value.crminvoiceid.toLowerCase() == entitlement.crminvoiceid.toLowerCase());
          if (invoice.length >= 1) {
            entitlement.crminvoicename = invoice[0].crminvoicename;
          } else {
            entitlement.crminvoicename = "";
          }

          if (!productMap.has(getEntitlementsResult.entitlements[e].productname)) {
            productMap.set(getEntitlementsResult.entitlements[e].productname, getEntitlementsResult.entitlements[e].productname);
            this.products.push(getEntitlementsResult.entitlements[e].productname);
          }

          this.entitlements.push(entitlement);
        }
      }
      this.dataSource = new MatTableDataSource(this.entitlements);
      this.hasData = this.dataSource.data.length > 0;
      this.dataSource.paginator = this.paginator ?? null;
      this.dataSource.sort = this.sort ?? null;
      splash.hide();
    }, () => {
      this.snackMsg.openSnackBar("An Error Has Occurred.", 5000);
      this.splash.hide();
    });
  }

  ngOnInit(): void {
  }


  ngAfterViewInit(): void {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator ?? null;
      if (this.sort != undefined) this.sort.sortChange.subscribe(next => {
        if (this.paginator != null) this.paginator.pageIndex = 0;
      }, () => {
        this.snackMsg.openSnackBar("An Error Has Occurred.", 5000);
        this.splash.hide();
      });
    }
  }


  updateFilterPredicate(filterValues: string, column_data: ColumnData[]) {
    this.dataSource.filterPredicate = function (d: EntitlementData, filter: string): boolean {
      const filter_parts = filter.split("!$1$!");
      filter = filter_parts[0];
      const productFilter = filter_parts[1];
      const activated = Number(filter_parts[2]);
      const cid = Number(filter_parts[3]);
      let keepRow = true;
      let searchPO = true;
      let searchProductName = true;
      let searchTenasysEntitlementID = true;
      let searchSUAC = true;
      let searchLicense = true;
      let searchCustomerActivationComment = true;
      let searchUSBKey = true;
      let searchActivatedBy = true;
      let searchActivatedDate = true;
      let searchIPAddress = true;
      let searchCRMInvoiceName = true;
      let searchClassicInvoiceNumber = true;
      let searchClassicOrderNumber = true;
      let searchCreatedDate = true;
      let searchCIDClassicLicense = true;
      let searchFingerprint = true;
      function getVisibleByColumnId(columnid: string) {
        return column_data.filter(e => e.id == columnid).map(e => e.visible).pop();
      }
      if (column_data != null) {
        searchPO = getVisibleByColumnId("ponumber");
        searchCRMInvoiceName = getVisibleByColumnId("crminvoicename");
        searchProductName = getVisibleByColumnId("productname");
        searchTenasysEntitlementID = getVisibleByColumnId("entitlement");
        searchSUAC = getVisibleByColumnId("suac");
        searchLicense = getVisibleByColumnId("license");
        searchCustomerActivationComment = getVisibleByColumnId("comment");
        searchUSBKey = getVisibleByColumnId("usbkey");
        searchActivatedBy = getVisibleByColumnId("activatedby");
        searchFingerprint = getVisibleByColumnId("fingerprint");
        searchActivatedDate = getVisibleByColumnId("activateddate");
        searchIPAddress = getVisibleByColumnId("ipaddress");
        searchClassicInvoiceNumber = getVisibleByColumnId("classicinvoice");
        searchClassicOrderNumber = getVisibleByColumnId("classicorder");
        searchCreatedDate = getVisibleByColumnId("createddate");
        searchCIDClassicLicense = getVisibleByColumnId("cidclassiclicense");
      }

      // ensure case insensitivity
      filter = filter.toLowerCase();

      const foundProductName = searchProductName && d.productname != null && d.productname.toLowerCase().trim().indexOf(filter) != -1;
      const foundTenasysEntitlementID = searchTenasysEntitlementID && d.tenasysentitlementid != null && d.tenasysentitlementid.toLowerCase().trim().indexOf(filter) != -1;
      const foundActivatedDate = searchActivatedDate != null && d.activateddate != null && d.activateddate.toString().toLowerCase().indexOf(filter) != -1;
      const foundActivatedBy = searchActivatedBy && d.activatedby != null && d.activatedby.toLowerCase().trim().indexOf(filter) != -1;
      const foundLicense = searchLicense && d.license != null && d.license.toLowerCase().trim().startsWith(filter);
      const foundFingerprint = searchFingerprint && d.fingerprint != null && d.fingerprint.toLowerCase().trim().indexOf(filter) != -1;
      const foundCustomerActivationComment = searchCustomerActivationComment && d.customeractivationcomment != null && d.customeractivationcomment.toLowerCase().trim().indexOf(filter) != -1;
      const foundIPAddress = searchIPAddress && d.ipaddress != null && d.ipaddress.toLowerCase().trim().indexOf(filter) != -1;
      const foundCRMInvoiceName = searchCRMInvoiceName && d.crminvoicename != null && d.crminvoicename.toLowerCase().trim().indexOf(filter) != -1;
      const foundPO = searchPO && d.ponumber != null && d.ponumber.toLowerCase().trim().indexOf(filter) != -1;
      const foundUSBKey = searchUSBKey && d.usbkey != null && d.usbkey.toLowerCase().trim().indexOf(filter) != -1;
      const foundCreatedDate = searchCreatedDate != null && d.createddate != null && d.createddate.toString().toLowerCase().indexOf(filter) != -1;
      const foundSUAC = searchSUAC && d.suac != null && d.suac.toLowerCase().indexOf(filter) != -1;
      const foundClassicInvoiceNumber = searchClassicInvoiceNumber && d.classicinvoicenumber != null && d.classicinvoicenumber.toLowerCase().indexOf(filter) != -1;
      const foundClassicOrderNumber = searchClassicOrderNumber && d.classicordernumber != null && d.classicordernumber.toLowerCase().indexOf(filter) != -1;
      const foundCIDClassicLicense = searchCIDClassicLicense && d.cidclassiclicense != null && d.cidclassiclicense.toLowerCase().startsWith(filter);
      if (filter.length == 0 || foundProductName || foundTenasysEntitlementID || foundActivatedDate || foundActivatedBy ||
        foundLicense || foundFingerprint || foundCustomerActivationComment || foundIPAddress || foundCRMInvoiceName || foundPO ||
        foundUSBKey || foundCreatedDate || foundSUAC || foundClassicInvoiceNumber ||
        foundClassicOrderNumber || foundCIDClassicLicense) {
        keepRow = true;
      } else {
        keepRow = false;
      }

      if (keepRow) {
        if (cid === 0 || (cid === 1 && (d.usbkey !== "" && d.usbkey !== null)) || (cid === 2 && (d.usbkey === "" || d.usbkey === null))) {
          keepRow = true;
        } else {
          keepRow = false;
        }
      }

      if (keepRow) {
        if (productFilter.toLowerCase() === "" || productFilter.toLowerCase() === "all" || d.productname.toLowerCase() === productFilter.toLowerCase()) {
          keepRow = true;
        } else {
          keepRow = false;
        }
      }

      if (keepRow) {
        if (activated == 0
          || (activated == 1 && !(d.license == null || d.license == ""))
          || (activated == 2 && (d.license == null || d.license == ""))) {
          keepRow = true;
        } else {
          keepRow = false;
        }
      }
      return keepRow;
    }
    this.dataSource.filter = filterValues;
  }

  selectColumns() {
    this.columnManager.openSelectColumnsDialog(
      this.dialog, this.dataSource,
      () => this.applyFilter(),
      this.saveConfig, this.snackMsg, this.auth
    );
  }

  showDetail(datacolumn: string, input: string) {
    if (input != null && input.toString().trim() != "") {
      const dialogRef = this.dialog.open(CellpopupComponent, {
        data: {
          datavalue: input,
          datacolumn: datacolumn,
          url: ""
        },
        width: '35vw'
      });

      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  isActive(license: string) {
    return (license != undefined && license != "") ? "True" : "False";
  }

  public copy(input: string) {
    const selBox = document.createElement('textarea');
    const inputRemoveBR = input.replace(new RegExp('<br />', 'gi'), '\r\n');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = inputRemoveBR;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy', false, null);
    document.body.removeChild(selBox);
  }

  public getReservedButtonText() {
    if (this.filterReservedState == 0) return 'All';
    if (this.filterReservedState == 1) return 'False';
    if (this.filterReservedState == 2) return 'True';
    return 'All';
  }

  public getProductList() {
    return this.products;
  }

  public setProductFilter(product) {
    this.filterProductState = product;
    this.applyFilter();
  }

  public setUsedFilter(used) {
    this.filterActivatedState = used;
    this.applyFilter();
  }

  public setCIDFilter(cid) {
    this.filterCidState = cid;
    this.applyFilter();
  }

  applyFilterEvent(filterEvent: Event) {
    if (filterEvent != null) {
      this.filterString = (filterEvent.target as HTMLInputElement).value;
      this.applyFilter();
    }
  }

  applyFilter(newFilter?: string) {
    if (newFilter != null) {
      this.filterString = newFilter;
    }
    const fullFilter = `${this.filterString}${this.stringSplit}${this.filterProductState}${this.stringSplit}${this.filterActivatedState}${this.stringSplit}${this.filterCidState}`;
    this.updateFilterPredicate(fullFilter, this.columnManager.columnData());
    this.hasData = this.dataSource.data.length > 0;
    if (this.paginator != null) this.dataSource.paginator = this.paginator;
    if (this.sort != null) this.dataSource.sort = this.sort;
    this.download_started = false;  // allow the download button to be clicked again
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  downloadFileByRecord($event) {
    if (!this.download_started) {
      this.download_started = true;
      const today = formatDate(Date.now(), 'yyyy-MMM-dd_HH-mm-ss', 'en_US');
      const downloadName = this.accountname + "_" + today + "_" + "TenAsysEntitlements.csv";
      this.spinner_0.show("spinner_0");
      this.snackMsg.openSnackBar("Creating TenAsys Entitlement data download: " + downloadName, 8000);
      const page = 1;
      const pagesize = 1000000;
      this.ems.GetExport<Blob>(this.accountid, this.filterCidState,
        this.filterActivatedState, this.filterReservedState,
        this.filterProductState, this.filterString, page, pagesize, false)
        .subscribe(blob => {
          saveAs(blob, downloadName);
        },
          err => {
            this.snackMsg.openSnackBar("An error occurred during the creation of your TenAsys Entitlement data download.", 5000 * 4);
            this.spinner_0.hide("spinner_0")
            this.download_started = false;
          },
          () => {
            this.spinner_0.hide("spinner_0")
            this.download_started = false;
          });
    } else {
      this.snackMsg.openSnackBar("The process to create TenAsys Entitlement data download already in progress.  Please wait!", 5000);
    }
  }
}


